var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.05L0.5 7.55L1 7.55L12.1009 7.55C14.5766 7.55 16.5963 9.55794 16.5963 12L16.5963 12.5L17.0963 12.5L18.2064 12.5L18.7064 12.5L18.7064 12C18.7064 9.55794 20.7262 7.55 23.2018 7.55L23.7018 7.55L23.7018 7.05L23.7018 5.95L23.7018 5.45L23.2018 5.45C20.7262 5.45 18.7064 3.44206 18.7064 1L18.7064 0.5L18.2064 0.5L17.0963 0.499999L16.5963 0.499999L16.5963 0.999999C16.5963 3.44206 14.5766 5.45 12.1009 5.45L1 5.45L0.500001 5.45L0.500001 5.95L0.5 7.05Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkWhite);
export default __webpack_public_path__ + "static/media/spark-white.bad94ad39f94dfdb968d7712c8a1b425.svg";
export { ForwardRef as ReactComponent };